<template>
<div class="table-section">
  <div class="section-header">
    <div class="section-label">
        معاملات شما
    </div>
      <div class="switch-comp" :style="{maxWidth:'214px'}">
        <button class="switch-comp-button" :class="{'active-opt':currencyType==='Crypto' }" @click="currencyType='Crypto'">رمزارز</button>
        <button class="switch-comp-button" :class="{'active-opt':currencyType==='Gold' }" @click="currencyType='Gold'">طلا و سکه</button>
      </div>

  </div>
  <template v-if="currencyType==='Crypto'">
    <div class="table-container" >
<!--      <perfect-scrollbar ref="scroll">-->
        <table class="table" >
          <tr class="table-header">
            <td>بازار</td>
            <td class="resp-2">زمان و تاریخ</td>
            <td >سمت</td>
            <td class="resp-3">نوع</td>
            <td class="resp-2">قیمت واحد</td>
            <td class="resp-1">مقدار</td>
            <td class="resp-1">کارمزد</td>
            <td>مبلغ کل</td>
            <td class="resp-1">سود / زیان </td>
          </tr>
          <tr v-for="(item ,index) in transactions" :key="index">
            <td style="text-align: right">  {{item.orderType.includes('BUY')? $coins[item.destinationCoin].persianName +'-'+  $coins[item.sourceCoin].persianName : $coins[item.sourceCoin].persianName +'-'+  $coins[item.destinationCoin].persianName }}

            </td>
            <td class="resp-2">{{ $G2J(item.createdAtDateTime) }}</td>
            <td class="hide-under-600"
                :class="{'red' : item.orderType.includes('SELL'), 'green' : item.orderType.includes('BUY') }">
              {{ item.orderType.includes('SELL') ? 'فروش' : 'خرید' }}

            </td>
            <td class="resp-3"
                :class="{'red' : item.orderType.includes('SELL'), 'green' : item.orderType.includes('BUY') }">
              {{ $orderType[item.orderType] }}
            </td>
            <td class="resp-2">{{ $toLocal(item.unitPrice, $decimal['TOMAN']) }}</td>
            <td class="resp-1">{{ item.amount.toLocaleString() }}</td>
            <td class="resp-1">{{ item.wagePercent }}</td>
            <td class="hide-under-400">{{ $toLocal(item.calculatedPriceInTomanMarket, $decimal['TOMAN']) }}</td>
            <td class="resp-1">0%</td>
          </tr>
        </table>
<!--      </perfect-scrollbar>-->
    </div>
  </template>


  <div class="table-container" v-if="currencyType==='Gold'">>
    <table class="table" v-if="currencyType==='Gold'">
      <tr class="table-header">
        <td>بازار</td>
        <td class="resp-2">زمان و تاریخ</td>
        <td >سمت</td>
        <td class="resp-3">نوع</td>
        <td class="resp-2">قیمت واحد</td>
        <td class="resp-1">مقدار</td>
        <td class="resp-1">کارمزد</td>
        <td>مبلغ کل</td>
        <td class="resp-1">سود / زیان </td>
      </tr>
      <tr class="table-row" v-for="(trade,index) in goldTrades" :key="index">
        <td >{{ trade.title }}</td>
        <td class="resp-2">{{ trade.date }}</td>
        <td  :class="{negative:trade.orderType==='SELL',positive:trade.orderType==='BUY'}">{{ dict[trade.orderType] }}</td>
        <td class="resp-3">{{ dict[trade.marketType] }}</td>
        <td class="resp-2">{{ trade.unitPrice.toLocaleString() }}</td>
        <td class="resp-1"> {{ trade.amount }}</td>
        <td class="resp-1"> {{ trade.commission }}</td>
        <td > {{ trade.totalPrice.toLocaleString() }}</td>
        <td class="resp-1">
          <div :class="{positive:trade.profit>0,negative:trade.profit<0}" dir="ltr"> <span v-if="trade.profit>0">+</span>{{ trade.profit.toLocaleString() }}</div>
        </td>

      </tr>
    </table>

  </div>

  </div>
</template>

<script>
import dataSet from '../Wallet/dataSet.json'
export default {
  name: "TradesTable.vue",
  data(){
    return{
      transactions:[],

      currencyType:'Crypto',
      trades:dataSet.dataSet,
      dict: {"SUCCESS": "موفق", 'FAIL': "ناموفق", "SELL": 'فروش', "BUY":  'خرید', "LIMIT": 'حد', "MARKET":  'بازار'},
      goldTrades: [
        {
          "coinName": "Tomam",
          "unitPrice":432322,
          "totalPrice":4232332,
          "profit":-34234,
          "title": "تمام سکه",
          "orderType": "BUY",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "marketType": "MARKET",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "nim",
          "unitPrice":432322,
          "totalPrice":4232332,
          "profit":34234,
          "title": "نیم سکه",
          "orderType": "SELL",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "marketType": "MARKET",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "Tomam",
          "unitPrice":432322,
          "totalPrice":4232332,
          "profit":-34234,
          "title": "تمام سکه",
          "orderType": "BUY",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "marketType": "MARKET",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "nim",
          "unitPrice":432322,
          "totalPrice":4232332,
          "profit":-34234,
          "title": "نیم سکه",
          "orderType": "BUY",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "marketType": "LIMIT",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "rob",
          "unitPrice":432322,
          "totalPrice":4232332,
          "profit":34234,
          "title": "ربع سکه",
          "orderType": "SELL",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "marketType": "LIMIT",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "Tomam",
          "unitPrice":432322,
          "totalPrice":4232332,
          "profit":34234,
          "title": "تمام سکه",
          "orderType": "BUY",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "marketType": "LIMIT",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "rob",
          "unitPrice":432322,
          "totalPrice":4232332,
          "profit":-34234,
          "title": "ربع سکه",
          "orderType": "SELL",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "marketType": "MARKET",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "mesghal",
          "unitPrice":432322,
          "totalPrice":4232332,
          "profit":-34234,
          "title": "مثقال",
          "orderType": "SELL",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "marketType": "LIMIT",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },


      ],
page:1,
      lastPage:10,
    }
  },
  methods:{
    async getTradeHistory() {


      if (this.page <= this.lastPage) {
        this.page++
        let res = await this.$axios.get('/trades', {
          params: {
            // marketType: this.$route.params.tradeFrom + '_' + this.$route.params.tradeTo,
            // marketType : this.marketType,
            type:'P2P',
            page: this.page,
            size: 20
          }
        })

        // res.content = res.content.filter(i => !i.orderType.includes('EXCHANGE'));
        // console.log('trade history is here', res.content)
        this.transactions = res.content;
      }

    },
  },


  mounted(){
    this.getTradeHistory()

  },
}
</script>

<style scoped>


td{
  font-size: clamp(10px,1.5vw,14px);
}

.positive {
  color: #04B3A2;
}

.negative {
  color: #D94F68;
}
.table-row{
  font-size: clamp(11px,1.3vw,13px);
  color: #D7C8C8;
  align-items: center;


}
td:last-child{
  text-align: left;
}
td{
  padding: 15px 0px;
}
.table-header > td{
  padding: 30px 0px;


}

.table-container{
  max-height: 300px;
  color: white;
  overflow-y: scroll;
  margin-top: 60px;
}
.table-header{
  font-size: clamp(12px,1.3vw,14px);
  color: #D7C8C8;
  font-weight: bold;
  top: 0px;

}
.table-section{
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 27px 34px 21px 34px;
  flex-grow: 1;
}

.active-opt{
  background: rgba(215, 200, 200, 0.12)!important;
  color: rgba(17, 153, 250, 1)!important;
}
.switch-comp{
  display: flex;
  align-items: center;
  column-gap: 7px;
  flex-wrap: wrap;
  flex-grow: 1;
}
.switch-comp-button{
  background: transparent;
  color: rgba(215, 200, 200, 1);
  border-radius: 4px;
  border: 0.5px solid rgba(215, 200, 200, 0.35);
  cursor: pointer;
  white-space: nowrap;
  font-size: clamp(10px , 1.1vw , 12px);
  height:25px;
  flex-grow: 1;
}

.section-label{
  font-size: clamp(14px,1.5vw,16px);
  font-weight: bold;
  color: white;
}

.section-header{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 15px;
}


@media(max-width:1200px){

  .resp-1{
    display: none;
  }
}
@media(max-width:900px){
  .resp-2{
    display: none;
  }
}

@media(max-width:600px){
  .resp-3{
    display: none;
  }
}
</style>